import { ECardPurpose } from '~/enums';
import useTranslate from './useTranslate';

export const useCardPurposeOptions = () => {
  const t = useTranslate();

  const cardPurposeOptions = [
    {
      label: t('CreditCardPurpose.Inventory') as string,
      value: ECardPurpose.Inventory,
    },
    {
      label: t('CreditCardPurpose.ToolsAndEquipment') as string,
      value: ECardPurpose.ToolsAndEquipment,
    },
    {
      label: t('CreditCardPurpose.ComputerSoftware') as string,
      value: ECardPurpose.ComputerSoftware,
    },
    {
      label: t('CreditCardPurpose.OfficeExpenses') as string,
      value: ECardPurpose.OfficeExpenses,
    },
    {
      label: t('CreditCardPurpose.SalariesAndConsultancy') as string,
      value: ECardPurpose.SalariesConsultancy,
    },
    {
      label: t('CreditCardPurpose.Marketing') as string,
      value: ECardPurpose.Marketing,
    },
    {
      label: t('CreditCardPurpose.Traveling') as string,
      value: ECardPurpose.Travel,
    },
    {
      label: t('CreditCardPurpose.MealsAndDrinks') as string,
      value: ECardPurpose.MealsAndDrinks,
    },
    {
      label: t('CreditCardPurpose.Other') as string,
      value: ECardPurpose.OtherPurpose,
    },
  ];

  const isValidOption = (value: string | null): value is ECardPurpose => {
    return Object.values(ECardPurpose).includes(value as ECardPurpose);
  };

  return { cardPurposeOptions, isValidOption };
};
